interface Props {
  isOpen: boolean;
  closeModal: () => void;
}

export const DeleteModal = ({ isOpen, closeModal }: Props) => {
  if (!isOpen) return null;

  return null;
};
